var __WEBPACK_NAMESPACE_OBJECT__ = RobloxThumbnail3d;